// extracted by mini-css-extract-plugin
export default {"home":"Home_home__y7gd9","content":"Home_content__0gRrs","links":"Home_links__BWINk","linkButton":"Home_linkButton__DegEK"};